{
  "version": 1,
  "asset_id": "d2058c5b-7141-4c0d-8297-f50d8600c919",
  "project_id": "ab945133-766b-45c0-8595-d741bb5019f6",
  "url": "/__l5e/assets-v1/d2058c5b-7141-4c0d-8297-f50d8600c919/qmsr-compliance-what.png",
  "r2_key": "a/v1/ab945133-766b-45c0-8595-d741bb5019f6/d2058c5b-7141-4c0d-8297-f50d8600c919/qmsr-compliance-what.png",
  "original_filename": "qmsr-compliance-what.png",
  "size": 1770402,
  "content_type": "image/png",
  "created_at": "2026-06-19T08:18:37Z"
}
